import React from 'react';
import { translate } from '@fiverr-private/i18n-react';
import { ConfirmModal } from '../ConfirmModal';

export interface RemoveDocumentProps {
    onRemove: () => Promise<void>;
    isPremiumPackage: boolean;
    isOpen: boolean;
    onClose: () => void;
}

const TRANSLATION_PREFIX = 'legal_documents_package.confirm_modal.remove_document';

export const RemoveDocumentConfirmModal = ({ onRemove, isPremiumPackage, onClose, isOpen }: RemoveDocumentProps) => {
    const resolveTranslationKey = (key: string) => {
        const suffix = isPremiumPackage ? 'premium' : 'free';
        return translate(`${TRANSLATION_PREFIX}.${suffix}.${key}`);
    };

    return (
        <ConfirmModal
            isOpen={isOpen}
            onClose={onClose}
            onConfirm={onRemove}
            title={resolveTranslationKey('title')}
            description={resolveTranslationKey('description')}
            confirmText={resolveTranslationKey('confirmText')}
        />
    );
};
